import React from 'react';
import { Input, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { Link } from 'react-router-dom';

function genStyles(props: any) {
  const { size } = props;
  return {
    root: {
      // padding: '10px 10px 0 10px',
      display: 'flex',
      alignItems: 'center'
      // justifyContent: 'space-around'
    },
    searchBar: {
        // all: 'unset',
        padding: size === 'sm' ? '5px 60px 5px 20px' : '3px 180px 3px 10px',
        fontSize: 14,
        backgroundColor: '#F4F4F6',
        border: 'none',
        borderRadius: 5,
        // flex: 4,
        "&&:before": {
            borderBottom: "none"
          },
          "&&:after": {
            borderBottom: "none"
          }
      },
      link: {
        display: 'flex',
        alignItems: 'center'
      },
      addBtn: {
        backgroundColor: '#0079E4',
        // flex: 1,
        marginLeft: 15,
        color: '#fff',
        width: size === 'sm' ? 30 : 25,
        height: size === 'sm' ? 30 : 25,
        border: 'unset',
        borderRadius: 5,
        flex: 1,
        fontSize: size === 'sm' ? 20 : 15
    },
  };
}

export interface SearchBarProps {
  searchText: string;
  searchFunction: (e: any) => void;
  size?: string;
  addBtnLink: string;
  className?: any,
  value?: string,
  styles?: any
}

export default (props: SearchBarProps): JSX.Element => {
    const { searchText, searchFunction, size='sm', addBtnLink, value } = props;

    const styles = genStyles({size});

    return (
        // <input style={styles.searchBar} placeholder={searchText} onChange={searchFunction} />
        <div style={styles.root}>
          <Input
          disableUnderline= {true}
              onChange={(e) => searchFunction(e.target.value)}
              startAdornment={<InputAdornment position="start"><SearchIcon style={{color: '#BFBFC1'}}/></InputAdornment>}
              style={{...styles.searchBar, ...props.styles}}
              placeholder={searchText}
              onFocus={(e: any) => e.target.select()}
              value={value}
            />
            <Link to={addBtnLink} style={styles.link}>
              <button className='cursor-pointer' style={styles.addBtn}>+</button>
            </Link>
      </div>
    );
}